import { incomingAlarmListState } from '../state/incomingAlarmListState';
import { ALARM_LIST_REQUEST, ALARM_LIST_SUCCESS , IMAGE_LIST_SUCCESS,UPDATED_ALARM_STATUS_LIST_SUCCESS,Fetch_All_Region_Data1} from '../actions/incomingAlarmListAction';

var initialStatusCode = '';

export function incomingAlarmListReducer(state = incomingAlarmListState, action) {
    switch (action.type) {
        case ALARM_LIST_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading
            })
        case ALARM_LIST_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                alarmList: action.list,
                pageNumber:action.pageNumber,
                pageSize:action.pageSize,
                totalRecord:action.totalRecord,
                errorCode: action.errorCode,
                messageLabel: action.message, 
                statusCode: action.statusCode
            })
        case IMAGE_LIST_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                imageList: action.list,
                errorCode: action.errorCode,
                messageLabel: action.message, 
                statusCode: action.statusCode
            })
            case UPDATED_ALARM_STATUS_LIST_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                alarmReceiverList: action.list,
                errorCode: action.errorCode,
                messageLabel: action.message, 
                statusCode: action.statusCode
            })
             case Fetch_All_Region_Data1:
                                                        return Object.assign({}, state, {
                                                            errorCode : action.errorCode,
                                                            statusCode : action.statusCode,
                                                            regionList : action.regionList
                                                        })
        
        default:
            return state;
    }
}
